@if (showBanner) {
  <div class="cookie-consent">
    <span class="cc-message">
      This website uses cookies to log in and remember your account.<br />Please check our cookie policy. <a href="./terms-and-conditions">About</a>
    </span>
    <div class="cc-compliance">
      <button type="button" class="cc-btn cc-dismiss" (click)="dismiss()">Got it!</button>
    </div>
  </div>
}
